var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "#ececec",
    stroke: "#ececec",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.447 5.91v.75h1.593a1.783 1.783 0 0 1 1.783 1.783v6.754a1.783 1.783 0 0 1-1.783 1.783H4.221a1.783 1.783 0 0 1-1.783-1.783V5.066a1.783 1.783 0 0 1 1.783-1.783h8.443a1.783 1.783 0 0 1 1.783 1.783v.844Zm-.939.75h.75V5.066a1.594 1.594 0 0 0-1.594-1.594H4.221a1.594 1.594 0 1 0 0 3.188h9.287Zm3.377 6.755h.75v-3.189h-1.594a1.594 1.594 0 1 0 0 3.188h.844Zm0-3.378h.75V8.443a1.594 1.594 0 0 0-1.594-1.594H4.221c-.203 0-.404-.034-.595-.101l-.999-.352v8.801a1.594 1.594 0 0 0 1.594 1.595h11.82a1.594 1.594 0 0 0 1.594-1.595v-1.594h-1.594a1.783 1.783 0 0 1 0-3.566h.844Z",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWallet);
export default __webpack_public_path__ + "static/media/icon-wallet.ab1cb727ec1eb14c74194db911c467f8.svg";
export { ForwardRef as ReactComponent };